import { render, staticRenderFns } from "./CostIncomeView.vue?vue&type=template&id=72db174b&scoped=true&"
import script from "./CostIncomeView.vue?vue&type=script&lang=js&"
export * from "./CostIncomeView.vue?vue&type=script&lang=js&"
import style0 from "./CostIncomeView.vue?vue&type=style&index=0&id=72db174b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72db174b",
  null
  
)

export default component.exports